import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import PopularTagsClicked from './Service';

// eslint-disable-next-line no-undef
import { __ } from '@wordpress/i18n';

function PopularTagsView({ options, dispatch, slug, preSelectedTags }) {
	const [activeItems, setActiveItems] = useState(preSelectedTags);

	const { isResetClicked } = useSelector((state) => state.jobsFormInput);

	useEffect(() => {
		if (isResetClicked) {
			setActiveItems([]);
		}
	}, [isResetClicked]);

	const popularTagsLists = options?.map(({ label, value }) => {
		let activeClass = activeItems.includes(value);

		/**
		 * If the values exists on redux state, then we need to add the active class
		 * This is to make sure that the active class is added when the user selects
		 * Reason for adding this is this item could be selected from other component
		 */
		if (!activeClass) {
			activeClass = preSelectedTags.includes(value);
		}
		return (
			<button
				className={`popular-tags__item ${
					activeClass ? 'popular-tags__item--active' : ''
				}`}
				onClick={() =>
					PopularTagsClicked(value, activeItems, setActiveItems, dispatch, slug)
				}
				type='button'
				key={`${label}-${value}`}
			>
				{label}
			</button>
		);
	});

	return (
		<div className='popular-tags'>
			<h2 className='ss-copy-default popular-tags__title'>
				{__('Popular searches', 'job')}
			</h2>
			<div className='popular-tags__list'>{popularTagsLists}</div>
		</div>
	);
}

PopularTagsView.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			label: PropTypes.string,
			type: PropTypes.string,
			value: PropTypes.string,
		}),
	),
	dispatch: PropTypes.func.isRequired,
	slug: PropTypes.string,
	preSelectedTags: PropTypes.arrayOf(PropTypes.string).isRequired,
};

// PopularTagsView.defaultProps = {
// 	options: [],
// 	slug: '',
// };

export default PopularTagsView;
